import { render, staticRenderFns } from "./StudyPatientAuditTrailView.vue?vue&type=template&id=3b5bcca5&scoped=true"
import script from "./StudyPatientAuditTrailView.vue?vue&type=script&lang=ts"
export * from "./StudyPatientAuditTrailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5bcca5",
  null
  
)

export default component.exports